<template>
  <div>
    <PesquisaDentistaModal
        v-if="modalSelecionarDentista"
        v-model="modalSelecionarDentista"
        @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
        @confirmarDentistaSelecionado="selecionarDentista"
    />
    <ConfirmTextModal
        v-if="modalCancelar"
        v-model="modalCancelar"
        mensagemFinal="para cancelar o orçamento."
        palavraChave="cancelar" @modalConfirmTextAcaoVoltar="fecharModalCancelarOrcamento"
        @modalConfirmTextAcaoConfirmar="cancelarOrcamento"
    />
    <ConfirmTextModal
        v-if="modalReabrir"
        v-model="modalReabrir"
        mensagemFinal="para reabrir o orçamento."
        palavraChave="reabrir" @modalConfirmTextAcaoVoltar="fecharModalReabrirOrcamento"
        @modalConfirmTextAcaoConfirmar="reabrirOrcamento"
    />
    <confirm-modal
        v-if="modalFinalizar"
        v-model="modalFinalizar"
        @modalAcaoCancelar="fecharModalFinalizarOrcamento"
        @modalAcaoConfirmar="tratarEventoFinalizarOrcamento"
        :persistencia="false"
        :maxWidth="500"
        textCancelar="Voltar"
        textConfirmar="Finalizar"
        mensagemInicial="Deseja realmente finalizar o orçamento "
        :mensagemMeio="orcamentoSelecionado.codigo"
        mensagemFinal="?"
    />
    <confirm-relatorio-modal
        v-if="modalGerarRelatorio"
        v-model="modalGerarRelatorio"
        :titulo="'Gerar orçamento ' + orcamentoSelecionado.codigo"
        @modalRelatorioAcaoCancelar="fecharModalGerarRelatorio"
        @modalRelatorioAcaoGerar="gerarRelatorioOrcamento"
    />
    <v-card elevation="0">
      <v-toolbar dark color="primary" elevation="0" class="container-header-orcamento">
        <v-toolbar-title>Orçamento <strong>{{ orcamentoSelecionado.codigo }}</strong></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row wrap align-center white class="pl-5 pr-5 pt-2 align-center">
          <v-tooltip top v-if="dadosGerais.statusApi === 'EM_ANDAMENTO'">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" rounded depressed color="primary" class="mr-2" @click="abrirModalSelecionarDentista">
                <v-icon>mdi-tooth</v-icon>
              </v-btn>
            </template>
            Selecionar dentista
          </v-tooltip>
          <v-tooltip right v-if="dadosGerais.statusApi !== 'EM_ANDAMENTO'">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" rounded depressed color="primary" disabled class="btn-disabled mr-2">
                <v-icon>mdi-tooth</v-icon>
              </v-btn>
            </template>
            Não é possível selecionar o dentista, o orçamento não está em andamento
          </v-tooltip>
          <CardDentistaSelecionadoOrcamento
              v-if="dentistaSelecionado"
              :desativar="dadosGerais.statusApi !== 'EM_ANDAMENTO'"
              :dentista-selecionado="dentistaSelecionado"
              @removerFiltroDentista="removerFiltroDentista"
              class="mr-5"
          />
        </v-row>
        <v-row wrap align-center white class="mt-4">
          <v-col cols="12" md="12" sm="12" xs="12">
            <v-textarea
                v-model="dadosGerais.descricao"
                name="descricao"
                label="Descrição"
                placeholder="Informe a descrição"
                :disabled="dadosGerais.statusApi !== 'EM_ANDAMENTO'"
                v-validate="{max: 500, required: true}"
                :error-messages="errors.collect('descricao')"
                counter
                filled
                auto-grow
            >
              <template v-slot:label>
                Descrição
                <span class="ml-1 red--text">*</span>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row wrap align-center white class="mt-0">
          <v-col cols="12" md="12" sm="12" xs="12">
            <orcamento-servico :idOrcamento="orcamentoSelecionado.id"
                               :statusOrcamento="dadosGerais.statusApi"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-container fluid>
          <v-row wrap align-center white class="row-bottom">
            <botao-cancelar @cancelar="cancelar" text="Voltar"/>
            <div style="display: flex; flex-direction: row" v-if="dadosGerais.statusApi === 'EM_ANDAMENTO'">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="botao-cancelar mr-9" @click="abrirModalCancelarOrcamento" depressed>
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </template>
                Cancelar orçamento
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="botao-finalizar mr-4" @click="abrirModalFinalizarOrcamento" outlined>
                    Finalizar
                    <v-icon class="ml-1">check</v-icon>
                  </v-btn>
                </template>
                Finaliza o orçamento
              </v-tooltip>
              <botao-salvar @salvar="atualizarOrcamento"/>
            </div>
            <div style="display: flex; flex-direction: row" v-if="dadosGerais.statusApi === 'FINALIZADO'">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="botao-finalizar mr-4" @click="abrirModalReabrirOrcamento" outlined>
                    Reabrir
                    <v-icon class="ml-1">rotate_left</v-icon>
                  </v-btn>
                </template>
                Reabrir o orçamento
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="abrirModalGerarRelatorio" outlined class="hover-primary">
                    Visualizar
                    <v-icon class="ml-1">mdi-eye</v-icon>
                  </v-btn>
                </template>
                Visualizar orçamento
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import BotaoSalvar from '@/views/components/BotaoSalvar.vue'
import {actionTypes} from '@/core/constants'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'
import CardDentistaSelecionadoOrcamento
from '@/views/pages/cadastros/paciente/comum/orcamento/CardDentistaSelecionadoOrcamento.vue'
import OrcamentoServico from '@/views/pages/cadastros/paciente/comum/orcamento/servicos/OrcamentoServico.vue'
import ConfirmTextModal from '@/views/components/ConfirmTextModal.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import ConfirmRelatorioModal from '@/views/components/ConfirmRelatorioModal.vue'

export default {
    name: 'OrcamentoEdicao',
    components: {
        ConfirmRelatorioModal,
        ConfirmModal,
        ConfirmTextModal,
        OrcamentoServico,
        CardDentistaSelecionadoOrcamento, PesquisaDentistaModal, BotaoSalvar, BotaoCancelar
    },
    props: {
        orcamentoSelecionado: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            dadosGerais: {
                pacienteId: null,
                dentistaId: null,
                descricao: null,
                statusApi: ''
            },
            dentistaSelecionado: null,
            modalSelecionarDentista: false,
            modalCancelar: false,
            modalFinalizar: false,
            modalReabrir: false,
            modalGerarRelatorio: false
        }
    },
    mounted() {
        this.setarDadosIniciais()
    },
    methods: {
        setarDadosIniciais() {
            this.dentistaSelecionado = this.orcamentoSelecionado.dentista
            this.dadosGerais = _.cloneDeep({
                id: this.orcamentoSelecionado.id,
                pacienteId: this.orcamentoSelecionado.pacienteId,
                dentistaId: this.orcamentoSelecionado.dentistaId,
                descricao: this.orcamentoSelecionado.descricao,
                statusApi: this.orcamentoSelecionado.statusApi
            })
        },
        cancelar() {
            this.$emit('cancelarEdicao')
        },
        async atualizarOrcamento() {
            if (await this.validarDadosFormulario()) {
                this.setarDadosGerais()
                this.setMensagemLoading('Atualizando orçamento...')
                const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.EDITAR_ORCAMENTOS, this.dadosGerais)
                if (resposta) {
                    this.mostrarNotificacaoSucessoDefault()
                }
            }
        },
        setarDadosGerais() {
            if (this.dentistaSelecionado) {
                this.dadosGerais.dentistaId = this.dentistaSelecionado.id
            }
        },
        async reabrirOrcamento() {
            const input = {
                orcamentoId: this.orcamentoSelecionado.id,
                statusOrcamento: 'EM_ANDAMENTO'
            }
            const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.ATUALIZAR_STATUS, input)
            if (resposta && resposta.status === 200) {
                this.dadosGerais.statusApi = 'EM_ANDAMENTO'
                this.mostrarNotificacaoSucesso('Orçamento reaberto com sucesso!')
            }
            this.fecharModalReabrirOrcamento()
        },
        async cancelarOrcamento() {
            const input = {
                orcamentoId: this.orcamentoSelecionado.id,
                statusOrcamento: 'CANCELADO'
            }
            const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.ATUALIZAR_STATUS, input)
            if (resposta && resposta.status === 200) {
                this.dadosGerais.statusApi = 'CANCELADO'
                this.mostrarNotificacaoSucesso('Orçamento cancelado com sucesso!')
            }
            this.fecharModalCancelarOrcamento()
        },
        async tratarEventoFinalizarOrcamento() {
            const input = {
                orcamentoId: this.orcamentoSelecionado.id,
                statusOrcamento: 'FINALIZADO'
            }
            const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.ATUALIZAR_STATUS, input)
            if (resposta && resposta.status === 200) {
                this.dadosGerais.statusApi = 'FINALIZADO'
                this.mostrarNotificacaoSucesso('Orçamento finalizado com sucesso!')
            }
            this.fecharModalFinalizarOrcamento()
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        selecionarDentista(dentista) {
            this.dentistaSelecionado = dentista
            this.fecharModalSelecionarDentista()
        },
        removerFiltroDentista() {
            this.dentistaSelecionado = null
        },
        abrirModalCancelarOrcamento() {
            this.modalCancelar = true
        },
        fecharModalCancelarOrcamento() {
            this.modalCancelar = false
        },
        abrirModalFinalizarOrcamento() {
            this.modalFinalizar = true
        },
        fecharModalFinalizarOrcamento() {
            this.modalFinalizar = false
        },
        abrirModalReabrirOrcamento() {
            this.modalReabrir = true
        },
        fecharModalReabrirOrcamento() {
            this.modalReabrir = false
        },
        abrirModalGerarRelatorio() {
            this.modalGerarRelatorio = true
        },
        fecharModalGerarRelatorio() {
            this.modalGerarRelatorio = false
        },
        async gerarRelatorioOrcamento(baixar) {
            await this.$store.dispatch(actionTypes.RELATORIOS.GERAR_RELATORIO_ORCAMENTO_FINALIZADO, {
                orcamentoId: this.orcamentoSelecionado.id,
                codigo: this.orcamentoSelecionado.codigo,
                baixar: baixar
            })
        }
    }
}
</script>


<style scoped lang="stylus">

.container-header-orcamento
  border-top-right-radius 0 !important
  border-top-left-radius 0 !important

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding 10px
  display flex
  justify-content space-between

.botao-cancelar:hover
  color orange !important

.botao-finalizar:hover
  color #22bb33 !important

</style>